import * as React from 'react';
import { IFlyoutProps } from './flyout-props';
import { FlyoutContent } from './flyout-content';

interface IFlyoutState {
    isFlyoutHidden: boolean;
    isClosingDialog?: boolean;
}

export class Flyout extends React.Component<IFlyoutProps, IFlyoutState> {
    private timeout?: number;

    static getDerivedStateFromProps(props: IFlyoutProps, state: IFlyoutState) {
        const { hidden } = props;
        if (hidden !== undefined) {
            return { isFlyoutHidden: hidden && !state.isClosingDialog };
        }
        return null;
    }

    constructor(props: IFlyoutProps) {
        super(props);
        const { hidden = false } = this.props;
        this.state = {
            isFlyoutHidden: hidden
        };
    }

    shouldComponentUpdate(nextProps: IFlyoutProps) {
        const { hidden } = this.props;
        if (!hidden && nextProps.hidden) {
            this.animateAndClose();
            return false;
        }
        return true;
    }

    render() {
        const { isFlyoutHidden } = this.state;
        if (isFlyoutHidden) {
            return null;
        }
        return this.renderFlyout();
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    private renderFlyout() {
        const {
            className, showModal, children, animationDuration, flyoutPosition,
            size, onRenderFooterContent, footerAlignment = 'right', title, preventDismissOnFocusOut,
            decorator, decoratorProps, showTitleSeparator
        } = this.props;
        const { isClosingDialog } = this.state;
        return (
            <FlyoutContent className={className} showModal={showModal} animationDuration={animationDuration}
                flyoutPosition={flyoutPosition} size={size} onRenderFooterContent={onRenderFooterContent}
                footerAlignment={footerAlignment} title={title} isClosingDialog={isClosingDialog} onCloseFlyout={this.closeFlyout}
                preventDismissOnFocusOut={preventDismissOnFocusOut} decorator={decorator} decoratorProps={decoratorProps}
                showTitleSeparator={showTitleSeparator}>
                {children}
            </FlyoutContent>
        );
    }

    private closeFlyout = () => {
        const { onDismiss, hidden } = this.props;

        if (onDismiss) {
            onDismiss();
            return;
        }

        if (hidden === undefined) {
            this.animateAndClose();
        }
    }

    private animateAndClose = () => {
        const { animationDuration = 250 } = this.props;
        const seconds = Math.max(animationDuration - 20, 0);
        this.setState({
            isClosingDialog: true
        });

        this.timeout = setTimeout(() => {
            this.setState({
                isFlyoutHidden: true,
                isClosingDialog: false
            });
        }, seconds);
    }
}
